import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { BenefitsProps } from './TrialOnboardingBenefitsModal.types';

export const TRIAL_ONBOARDING_STATIC_URL = `${cdnPackagesUrl}/static/cloud/promo/trialOnboarding`;

const unitsMap: Record<string, string> = {
    ['ГБ']: 'гигабайт',
    ['ТБ']: 'терабайт',
    ['МБ']: 'мегабайт',
};

export const cloudBenefits: Array<BenefitsProps> = [
    {
        img: 'trialOnboardingInfoUnlimited',
        text: 'Безлимитное место для фото и видео с телефона',
    },
    {
        img: 'trialOnboardingInfoAI',
        text: 'Удаление дубликатов фото с нейросетью',
    },
    {
        img: 'trialOnboardingInfoSwipe',
        text: 'Разбор фото свайпами — смахиваете вправо или влево',
    },
];

export const mailBenefits: Array<BenefitsProps> = [
    {
        img: 'trialOnboardingInfoAd',
        text: 'Безрекламность — никаких баннеров',
    },
    {
        img: 'trialOnboardingInfoAttachment',
        text: 'Отправка вложений весом до 100 ГБ',
    },
    {
        img: 'trialOnboardingInfoMailCancel',
        text: 'Отмена отправки писем и уведомления о прочтении',
    },
];

export const getBenefitImageUrl = (name: string, isDark: boolean): string => {
    const theme = isDark ? 'Dark' : '';
    return `${TRIAL_ONBOARDING_STATIC_URL}/${name}${theme}.png`;
};

export const useTrialSpaceValue = (): string => {
    const trialSubscription = useSelector(BillingDataSelectors.getTrialSubscription);
    const space = trialSubscription?.space;

    if (!space) {
        return '';
    }

    const unitWord = unitsMap[space.units] ?? space.units;
    // eslint-disable-next-line no-irregular-whitespace
    return `${space.space} ${unitWord}`;
};

export const openTrialOnboardingBenefitsModal = () =>
    openPopupHelper({ popupName: popupNames.TRIAL_ONBOARDING_BENEFITS_MODAL, onClose: () => {} });
